import {
  anEntityInterface,
  mockEntitiesByListIdQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockEntitiesByListIdQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          entitiesByListIds: [anEntityInterface()],
          __typename: 'Query',
        },
      });
    }
  ),
];
